import { render, staticRenderFns } from "./ProfileCoupons.vue?vue&type=template&id=5b667cd5&scoped=true&"
import script from "./ProfileCoupons.vue?vue&type=script&lang=ts&"
export * from "./ProfileCoupons.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCoupons.vue?vue&type=style&index=0&id=5b667cd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b667cd5",
  null
  
)

export default component.exports